<template>
  <Layout :containers="containers">
    <template v-slot:header>
      <DefaultHeroBar
        :hasQuickStartCallout="false"
        :heroTitle="article.heroTitle"
        :heroDescription="article.heroDescription"
        :section="'articles'"
        :heroButtonText="article.heroButtonText"
        :heroButtonLink="article.heroButtonLink"
      />
    </template>
    <template v-slot:article>
      <Breadcrumb :isArticle="true" />
      <div class="section-padding">
        <ArticleContent :article="article" />
      </div>
    </template>
    <template v-slot:articles>
      <div class="section-padding">
        <ArticleTilesContainer
          :tiles="articleTiles"
          :articles="articles"
          @buttonClicked="readMore"
        />
      </div>
    </template>
  </Layout>
</template>

<script>
import HR from "../../common/HR.vue";
import Breadcrumb from "../../common/Breadcrumb.vue";
import TitleRow from "../../common/TitleRow.vue";
import Layout from "../../common/layouts/Layout.vue";
import DefaultHeroBar from "../../common/DefaultHeroBar.vue";
import ArticleTilesContainer from "../articles/ArticleTilesContainer.vue";
import ArticleContent from "./ArticleContent.vue";

export default {
  name: "Article",
  metaInfo() {
    return {
      title: this.article.metaTitle,
      meta: [
        {
          name: "description",
          content: this.article.metaDescription,
        },
        {
          property: "og:title",
          content: this.article.metaTitle,
        },
        {
          property: "og:image",
          content: this.whitelabel.metaData.articles.ogImage,
        },
        {
          property: "og:type",
          content: this.whitelabel.metaData.articles.ogType,
        },
        {
          property: "og:url",
          content: this.whitelabel.metaData.articles.ogUrl,
        },
        {
          property: "og:description",
          content: this.article.metaDescription,
        },
        {
          property: "og:site_name",
          content: this.whitelabel.metaData.articles.ogSiteName,
        },
      ],
    };
  },
  components: {
    DefaultHeroBar,
    ArticleTilesContainer,
    HR,
    Breadcrumb,
    TitleRow,
    Layout,
    ArticleContent,
  },
  data() {
    return {};
  },
  methods: {
    readMore(id) {
      const article = this.articles.find((article) => article.id === id);
      this.$router.push({
        name: "Article",
        params: {
          title: article.route,
        },
      });
    },
  },
  computed: {
    containers() {
      return [
        {
          name: "header",
          background: "countryPattern",
          class: "hero-banner",
        },
        {
          name: "article",
          hr: true,
        },
        {
          name: "social-media",
        },
        { name: "articles" },
        { name: "create-my-will" },
      ];
    },
    articleTiles() {
      return this.whitelabel.articleTiles;
    },
    articles() {
      return this.whitelabel.articles;
    },
    article() {
      return this.whitelabel.articles.find(
        (article) => article.route === this.$route.params.title
      );
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.article {
  padding-top: 20px;
}
</style>
